

export const pngHolidaysService = {
  // Papua New Guinea Gazette Holidays 2026
  // Source: PNG Government Gazette
  PNG_HOLIDAYS_2026: [
    {
      date: '2026-01-01',
      name: 'New Year\'s Day',
      type: 'public_holiday',
      description: 'National public holiday'
    },
    {
      date: '2026-04-03',
      name: 'Good Friday',
      type: 'public_holiday',
      description: 'Christian observance'
    },
    {
      date: '2026-04-04',
      name: 'Easter Saturday',
      type: 'public_holiday',
      description: 'Christian observance'
    },
    {
      date: '2026-04-06',
      name: 'Easter Monday',
      type: 'public_holiday',
      description: 'Christian observance'
    },
    {
      date: '2026-06-15',
      name: 'Queen\'s Birthday',
      type: 'public_holiday',
      description: 'National public holiday'
    },
    {
      date: '2026-07-23',
      name: 'Remembrance Day',
      type: 'public_holiday',
      description: 'National day of remembrance'
    },
    {
      date: '2026-09-16',
      name: 'Independence Day',
      type: 'public_holiday',
      description: 'PNG Independence Day celebration'
    },
    {
      date: '2026-12-25',
      name: 'Christmas Day',
      type: 'public_holiday',
      description: 'Christian observance'
    },
    {
      date: '2026-12-26',
      name: 'Boxing Day',
      type: 'public_holiday',
      description: 'National public holiday'
    }
  ],

  /**
   * Get all PNG public holidays for 2026
   */
  getPNGHolidays2026() {
    return this.PNG_HOLIDAYS_2026;
  },

  /**
   * Check if a date is a PNG public holiday
   */
  isPublicHoliday(date) {
    const dateStr = date instanceof Date ? date?.toISOString()?.split('T')?.[0] : date;
    return this.PNG_HOLIDAYS_2026?.some(holiday => holiday?.date === dateStr);
  },

  /**
   * Get holiday by date
   */
  getHolidayByDate(date) {
    const dateStr = date instanceof Date ? date?.toISOString()?.split('T')?.[0] : date;
    return this.PNG_HOLIDAYS_2026?.find(holiday => holiday?.date === dateStr);
  },

  /**
   * Format holidays for calendar display
   */
  formatForCalendar() {
    return this.PNG_HOLIDAYS_2026?.map(holiday => ({
      id: `png-holiday-${holiday?.date}`,
      title: `🇵🇬 ${holiday?.name}`,
      type: 'events',
      subtype: 'public_holiday',
      date: new Date(holiday?.date),
      department: 'all',
      priority: 'high',
      description: holiday?.description,
      isPublicHoliday: true
    }));
  }
};

export default pngHolidaysService;
